import {
  ADD_TO_CART,
  DELETE_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  CLEAR_CART,
  GET_CHECKOUT_QUESTIONS,
} from "../types";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";
export const addToCartAction =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    await dispatch({ type: ADD_TO_CART, payload: data });
    toast.success("Added to Cart");
    onSuccess();
  };

export const deleteCartAction = (payload) => async (dispatch) => {
  await dispatch({ type: DELETE_CART, payload });
};
export const increaseQuantity = (payload) => async (dispatch) => {
  await dispatch({ type: INCREASE_ITEM_QUANTITY, payload: payload });
};

export const addCartDetails = (payload) => async (dispatch) => {
  await dispatch({ type: "CART_DETAILS", payload: payload });
};

export const updateAddOns = (payload) => async (dispatch) => {
  await dispatch({ type: "UPDATE_ADDONS", payload: payload });
};

export const decreaseQuantity = (payload) => async (dispatch) => {
  await dispatch({ type: DECREASE_ITEM_QUANTITY, payload: payload });
};
export const clearCartAction = () => async (dispatch) => {
  await dispatch({ type: CLEAR_CART });
};

export const clearCartDetails = () => async (dispatch) => {
  await dispatch({ type: "CLEAR_CART_DETAILS" });
};

export const updateTip = (payload) => async (dispatch) => {
  await dispatch({ type: "TIP_DETAILS", payload: payload });
};
export const updateTable = (payload) => async (dispatch) => {
  await dispatch({ type: "TABLE_UPDATE", payload: payload });
};
export const updateDelivery = (payload) => async (dispatch) => {
  await dispatch({ type: "DELIVERY_UPDATE", payload: payload });
};

export const getCheckoutQuestions = (restaurantID) => async (dispatch) => {
  const questionsRef = firebase
    .firestore()
    .collection("checkoutQuestions")
    .where("restaurantID", "==", restaurantID)
    .orderBy("position", "asc");

  questionsRef.onSnapshot((snap) => {
    let questions = [];

    snap.forEach((doc) => {
      questions.push({ id: doc.id, ...doc.data() });
    });

    dispatch({
      type: GET_CHECKOUT_QUESTIONS,
      payload: questions,
    });
  });
};

export const getTableData = (restaurantID) => (dispatch) => {
  try {
    if (!restaurantID) return;
    const db = firebase.firestore();
    const restaurantRef = db.collection("table").doc(restaurantID);

    const unsubscribe = restaurantRef.onSnapshot((restaurantDoc) => {
      if (!restaurantDoc.exists) return;

      const restaurantData = restaurantDoc.data();
      if (!restaurantData) return;

      const { timer, totalTables } = restaurantData;
      const tablesRef = restaurantRef.collection("tables");

      tablesRef.onSnapshot(async (allTablesSnapshot) => {
        const allTablesData = {};
        const now = Date.now();
        for (const doc of allTablesSnapshot.docs) {
          const tableData = doc.data();
          const expireAt = tableData?.expireAt?.seconds
            ? tableData.expireAt.seconds * 1000
            : null;

          if (expireAt && expireAt + 5 * 60 * 1000 < now) {
            await doc.ref.update({
              customerId: null,
              occupiedAt: null,
              expireAt: null,
            });
          }
          allTablesData[doc.id] = { id: doc.id, ...tableData };
        }

        dispatch({
          type: "FETCH_ALL_TABLES_SUCCESS",
          payload: {
            timer,
            totalTables,
            allTables: allTablesData,
          },
        });
      });
    });

    return unsubscribe;
  } catch (error) {
    console.error("Error fetching tables:", error);
    toast.error(error.message || "Failed to fetch tables.");
  }
};

export const getAddOns = (addOnsArray) => (dispatch) => {
  try {
    if (!Array.isArray(addOnsArray) || addOnsArray?.length === 0) {
      console.warn("Invalid addOnsArray:", addOnsArray);
      return;
    }

    const unsubscribes = [];
    const collectedData = {};
    let receivedCount = 0;

    addOnsArray.forEach((addOnObj) => {
      const addOnID = addOnObj?.id;
      if (!addOnID || typeof addOnID !== "string") return;

      const addOnRef = firebase.firestore().collection("addOns").doc(addOnID);

      const unsubscribe = addOnRef.onSnapshot((doc) => {
        if (!doc.exists) return;

        const addOnData = doc.data();
        if (!addOnData) return;

        collectedData[addOnID] = { id: addOnID, ...addOnData };

        if (!collectedData[addOnID]._received) {
          collectedData[addOnID]._received = true;
          receivedCount++;
        }

        if (receivedCount === addOnsArray?.length) {
          const finalArray = Object.values(collectedData)?.map(
            ({ _received, ...rest }) => rest
          );

          dispatch({
            type: "FETCH_ADD_ONS",
            payload: finalArray,
          });
        }
      });

      unsubscribes.push(unsubscribe);
    });

    return () => unsubscribes.forEach((unsub) => unsub && unsub());
  } catch (error) {
    console.error("Error fetching addOns:", error);
    toast.error(error.message);
  }
};

export const setEndLoading = (tableId, loading) => ({
  type: "END_LOADING",
  payload: { tableId, loading },
});

export const EndTime =
  (restaurantID, tableId, customerId) => async (dispatch) => {
    try {
      dispatch(setEndLoading(tableId, true));

      const db = firebase.firestore();

      const tableRef = db
        .collection("table")
        .doc(restaurantID)
        .collection("tables")
        .doc(`table_${tableId}`);

      await tableRef.update({
        customerId: null,
        occupiedAt: null,
        expireAt: null,
      });

      const userTableInfoRef = db
        .collection("users")
        .doc(customerId)
        .collection("tableInfo");

      const userTableSnapshot = await userTableInfoRef.get();

      const batch = db.batch();
      userTableSnapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });

      await batch.commit();

      toast.success("Table time ended successfully.");
    } catch (error) {
      console.error(`Error updating table ${tableId}:`, error);
      toast.error("Failed to end table time.");
    } finally {
      dispatch(setEndLoading(tableId, false));
    }
  };

export const setExtendLoading = (tableId, loading) => ({
  type: "EXTEND_LOADING",
  payload: { tableId, loading },
});

export const ExtendTime =
  (restaurantID, tableId, customerId, timer) => async (dispatch) => {
    try {
      if (!restaurantID || !tableId || !customerId || !timer) {
        toast.error("Missing parameters to extend table time.");
        return;
      }

      dispatch(setExtendLoading(tableId, true));

      const db = firebase.firestore();

      const [value, unit] = timer.split(" ");
      const duration = Number(value);
      if (!value || !unit || isNaN(duration)) {
        toast.error("Invalid timer format.");
        return;
      }

      let expirationTimestamp = firebase.firestore.Timestamp.now();
      if (unit === "Min") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 1000
        );
      } else if (unit === "Hour") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 60 * 1000
        );
      }

      const tableRef = db
        .collection("table")
        .doc(restaurantID)
        .collection("tables")
        .doc(`table_${tableId}`);

      await tableRef.update({
        expireAt: expirationTimestamp,
      });

      const userTableInfoRef = db
        .collection("users")
        .doc(customerId)
        .collection("tableInfo");

      const userTableSnapshot = await userTableInfoRef.get();

      if (!userTableSnapshot.empty) {
        const batch = db.batch();
        userTableSnapshot.forEach((doc) => {
          batch.update(doc.ref, {
            expireAt: expirationTimestamp,
          });
        });
        await batch.commit();
      } else {
        console.warn("No tableInfo documents found for user.");
      }

      toast.success("Table time extended successfully.");
    } catch (error) {
      console.error(`Error updating table ${tableId}:`, error);
      toast.error("Failed to extend table time.");
    } finally {
      dispatch(setExtendLoading(tableId, false));
    }
  };

export const updateTableData =
  (restaurantID, customerID, tableNo, timer, name) => async () => {
    try {
      if (!timer || !customerID) return;

      const db = firebase.firestore();
      const restaurantRef = db.collection("table").doc(restaurantID);
      const tablesRef = restaurantRef.collection("tables");
      const tableNumber = Number(tableNo);
      const querySnapshot = await tablesRef
        .where("tableNo", "==", tableNumber)
        .get();

      if (querySnapshot.empty) {
        return;
      }
      const tableDoc = querySnapshot.docs[0];
      if (!tableDoc.exists) {
        return;
      }

      const [value, unit] = timer.split(" ");
      const duration = Number(value);
      let expirationTimestamp = firebase.firestore.Timestamp.now();

      if (unit === "Min") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 1000
        );
      } else if (unit === "Hour") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 60 * 1000
        );
      }

      const occupiedAt = firebase.firestore.FieldValue.serverTimestamp();

      await tableDoc.ref.update({
        restaurantId: restaurantID,
        customerId: customerID,
        occupiedAt: occupiedAt,
        expireAt: expirationTimestamp,
      });

      const userTableInfoRef = db
        .collection("users")
        .doc(customerID)
        .collection("tableInfo")
        .doc();

      await userTableInfoRef.set({
        customerId: customerID,
        occupiedAt: firebase.firestore.Timestamp.now(),
        expireAt: expirationTimestamp,
        tableNumber: tableNumber,
        restaurantName: name,
        restaurantId: restaurantID,
      });
    } catch (error) {
      console.error("Error occupying table:", error);
      toast.error(error.message || "Failed to occupy table.");
    }
  };

export const tableTimeEnd = (restaurantID, tableNo, customerId) => async () => {
  try {
    const db = firebase.firestore();
    const restaurantRef = db.collection("table").doc(restaurantID);
    const tablesRef = restaurantRef.collection("tables");
    const tableNumber = Number(tableNo);

    const querySnapshot = await tablesRef
      .where("tableNo", "==", tableNumber)
      .get();

    if (querySnapshot.empty) return;

    const tableDoc = querySnapshot.docs[0];
    if (!tableDoc.exists) return;

    await tableDoc.ref.update({
      customerId: null,
      occupiedAt: null,
      expireAt: null,
    });
    if (customerId) {
      const userTableInfoRef = db
        .collection("users")
        .doc(customerId)
        .collection("tableInfo");

      const subSnapshot = await userTableInfoRef.get();
      const batch = db.batch();

      subSnapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });

      await batch.commit();
    }

    toast.success(`Reservation of table ${tableNumber} has ended.`);
  } catch (error) {
    console.error("Error releasing table:", error);
    toast.error(error.message || "Failed to release table.");
  }
};

export const changeOrderType = (value) => (dispatch) => {
  dispatch({ type: "CHANGE_ORDER_TYPE", payload: value });
};

const extendLoader = (tableId, value) => async (dispatch) => {
  dispatch({
    type: "EXTEND_LOADING",
    payload: { tableId, loading: value },
  });
};
